module.exports = __webpack_public_path__ + "static/media/Lesson-7-30-Caring-is-the-Remedy.f83bdb10.pdf";